import { getExeStatus, setExeStatus } from "../utils/exeStatus";

/**
* represent the Voucher with its code and residual value
*/
const VoucherService = function (Cart, $q, Discount) {
  const exeStatus = getExeStatus();

  function focusVoucherInput() {
    requestAnimationFrame(function () {
      var forms = document.querySelectorAll('.voucher-form');
      var form = Array.prototype.find.call(forms, function (el) {
        return el.offsetParent !== null;
      });
      if (!form) { return; }
      var input = form.querySelector('input');
      if (input) {
        input.focus();
      }
    });
  }

  var thisObject = {
    item: null,
    residualValue: 0,
    code: '',
    resetItem: function () {
      this.item = null;
      this.code = '';
    },
    setItem: function (item) {
      this.item = item;
      this.code = item.identifier;
    },

    redeemError: '',
    /**
     * extracted from scope of the checkout-controller, because we have now
     * at least two scopes where we can redeem the voucher
     *
     * @param $scope
     */
    redeem: function ($scope) {

      var deferred = $q.defer();

      this.redeemError = '';
      exeStatus.voucher = 2;
      if (thisObject.code == "") {
        this.redeemError = $scope.translations[ "custom" ][ "no_voucher_code_error" ];
        focusVoucherInput();
        deferred.reject();
        return deferred.promise;
      }
      $scope.ajaxCall('cart', 'redeemvoucher', 'POST', { voucher: thisObject.code }, function (response) {
        exeStatus.voucher = '';

        if (response.status) {
          if (response.type === 'discounttype') {
            Discount.setDiscount(response.product, $scope);
            deferred.resolve(response);
            return;
          } else {
            response.product.productid = response.product.id;
            $scope.cartItems[ 'product' + '-' + response.product.id ] = response.product;
            thisObject.redeemError = "";
            $scope.showVoucherForm = false;
            thisObject.item = response.product;
            $scope.scrollCartToBottom();
            $scope.updateCartSum();
            Cart.paymentVoucher = thisObject;
            requestAnimationFrame(function () {
              var deleteBtn = document.getElementById('applied-voucher-delete-button');
              if (deleteBtn) {
                deleteBtn.focus();
              }
            });
          }
        } else {
          var error = response.error;

          Discount.showInfo = false;
          if (response.type === 'discounttype') {
            Discount.setError(response);
            Discount.showInfo = !!response.discountInfoLink;
          }
          thisObject.redeemError = error;
          focusVoucherInput();
          deferred.reject();
        }

        deferred.resolve(response);

      }, function (error) {
        exeStatus.voucher = 0;
        thisObject.redeemError = error;
        focusVoucherInput();

        deferred.reject(error);
      });
      return deferred.promise;
    },

    focusVoucherInput: focusVoucherInput,

    isVoucherTypeInCart: function ($scope) {
      var isVoucherTypeInCart = false;
      for (var key in $scope.cartItems) {
        if (!$scope.cartItems.hasOwnProperty(key)) {
          continue;
        }

        if ($scope.cartItems[ key ].vouchertypeid) {
          isVoucherTypeInCart = true;
          break;
        }
      }

      return isVoucherTypeInCart;
    }
  };

  setExeStatus(exeStatus);

  return thisObject;

};

export default VoucherService;
